import {Col, Grid, Row} from '@freecodecamp/react-bootstrap';
import React, {ReactElement, useEffect, useState} from 'react';
import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';

import AsSeenIn from './components/as-seen-in';
import Certifications from './components/certifications';
import LandingTop from './components/landing-top';
import Testimonials from './components/testimonials';

import './landing.css';
import LearnLayout from "../layouts/learn";
import Map from "../Map";
import {Spacer} from "../helpers";

function Landing(): ReactElement {
  const { t } = useTranslation();
    const [userAccessLevel, setUserAccessLevel] = useState(4);
    const [hasLevel9, setHasLevel9] = useState(false);
    const [isPremiumOnly, setIsPremiumOnly] = useState(false);
    useEffect(() => {
        const windowUrl = window.location.search;
        const params = new URLSearchParams(windowUrl);
        const rawTier = params.get('tier') || '4';
        // Parse tier as a comma-separated SET: base tiers 1-4 curate the certs;
        // level 9 unlocks the Developer Cheat Sheet Pack (one-time premium add-on).
        // Backward compatible: a single "?tier=1" still parses to [1].
        const levels = rawTier
            .split(',')
            .map((s) => parseInt(s, 10))
            .filter((n) => !isNaN(n));
        const baseLevels = levels.filter((n) => n >= 1 && n <= 4);
        const hasBase = baseLevels.length > 0;
        const has9 = levels.includes(9);
        // base tier = smallest 1-4 present; premium-only (9, no base) => 0 sentinel (no certs)
        setUserAccessLevel(hasBase ? Math.min(...baseLevels) : has9 ? 0 : 4);
        setHasLevel9(has9);
        setIsPremiumOnly(has9 && !hasBase);
        // console.log('https://connector.krakentech.net/api/v1/user-info/' + userId +'/' + cId)
        // if (userId) {
        //   axios
        //     .get('https://connector.krakentech.net/api/v1/user-info/' + userId +'/' + cId, {
        //       headers: {
        //         'Content-Type': 'application/json',
        //         'X-API-Key':
        //           'YgdUZLiGLYaRBZdhDjw2sjqWwmjEEl9LX07rCMJjulVNWjk5f9PPD1gCg9gxutUv'
        //       }
        //     })
        //     .then((response: ApiResponse) => {
        //       console.log('response---', response);
        //       const accessLevel: Array<number[]> =
        //         response?.data?.webshopAccessLevels;
        //       setUserAccessLevel(accessLevel[0]);
        //     })
        //     .catch(() => {
        //       console.log('Error');
        //       navigate('/404');
        //     });
        // }
    }, []);
  return (
    <>
      <Helmet>
        <title>{t('metaTags:title')}</title>
      </Helmet>
        <LearnLayout>
            <Helmet title={t('metaTags:title')} />
            <Grid>
                <Row>
                    <Col md={8} mdOffset={2} sm={10} smOffset={1} xs={12}>
                        <Map userAccessLevel={userAccessLevel} hasLevel9={hasLevel9} isPremiumOnly={isPremiumOnly} />
                        <Spacer size={2} />
                    </Col>
                </Row>
            </Grid>
        </LearnLayout>
    </>
  );
}

Landing.displayName = 'Landing';
export default Landing;
